// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export class Coordinates {
    static fromEvent(event) {
        return new Coordinates({ x: event.clientX, y: event.clientY });
    }
    static cursorOffset(current, start) {
        return new Coordinates({
            x: current.x - start.x + (current.scrollX - start.scrollX),
            y: current.y - start.y + (current.scrollY - start.scrollY),
        });
    }
    constructor({ x, y }) {
        this.__type = "Coordinates";
        this.scrollX = window.scrollX;
        this.scrollY = window.scrollY;
        this.x = x;
        this.y = y;
    }
}
